import React, { SVGProps } from 'react';

const NewsLetter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={28}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color="var(--secondaryBackground)"
    {...props}
    data-palette="NewsLetter">
    <path
      d="M18.666 7h3.5a1.167 1.167 0 0 1 1.167 1.167V21a2.334 2.334 0 0 1-4.666 0V5.833A1.167 1.167 0 0 0 17.5 4.667H5.833a1.167 1.167 0 0 0-1.167 1.166v14a3.5 3.5 0 0 0 3.5 3.5H21M9.334 9.333H14M9.334 14H14M9.334 18.667H14"
      stroke="var(--dropdownIconColor)"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewsLetter;
